/**
 * @function getCookie
 * @desc Gets the cookie of the name specified
 *
 * @param {Object} name - Name of cookie.
 *
 * @returns {string} cookie value
 */

export default (name: string): string | null => {
  const cookie = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookie != null ? cookie[2] : null;
};
